import { E_RouterNames } from "@/router/types"
import VueRouter, { Route, RouteConfig, RouterOptions } from "vue-router"

const routeRepair: RouteConfig[] = [{
    path: '/inspectionRepairLib',
    name: E_RouterNames.inspectionRepairLib,
    component: () => import(
    /* webpackChunkName: "spotCheck_inspectionRepairLib" */ "./view/InspectionRepairLib/InspectionRepairLib.vue"
    )
}, {
    path: '/inspectionRepairLibAddEdit',
    name: E_RouterNames.inspectionRepairLibAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionRepairLib,
    },
    component: () => import(
    /* webpackChunkName: "spotCheck_inspectionRepairLib" */ "./view/InspectionRepairLibAddEdit/InspectionRepairLibAddEdit.vue"
    )
}, {
    path: '/inspectionRepair',
    name: E_RouterNames.inspectionRepair,
    component: () => import(
    /* webpackChunkName: "spotCheck_inspectionRepair" */ "./view/InspectionRepair/InspectionRepair.vue"
    )
}, {
    path: '/inspectionRepairAddEdit',
    name: E_RouterNames.inspectionRepairAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionRepair,
    },
    component: () => import(
    /* webpackChunkName: "spotCheck_inspectionRepairLib" */ "./view/InspectionRepairAddEdit/InspectionRepairAddEdit.vue"
    )
},]

const routeUpkeep: RouteConfig[] = [{
    path: '/inspectionUpkeepLib',
    name: E_RouterNames.inspectionUpkeepLib,
    component: () => import(
    /* webpackChunkName: "spotCheck_InspectionUpkeepLib" */ "./view/InspectionUpkeepLib/InspectionUpkeepLib.vue"
    ),
}, {
    path: '/inspectionUpkeepLibAddEdit',
    name: E_RouterNames.inspectionUpkeepLibAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionUpkeepLib
    },
    component: () => import(
    /* webpackChunkName: "spotCheck_InspectionUpkeepLib" */ "./view/InspectionUpkeepLibAddEdit/InspectionUpkeepLibAddEdit.vue"
    ),
}, {
    path: '/inspectionUpkeep',
    name: E_RouterNames.inspectionUpkeep,
    component: () => import(
    /* webpackChunkName: "spotCheck_InspectionUpkeep" */ "./view/InspectionUpkeep/InspectionUpkeep.vue"
    ),
}, {
    path: '/inspectionUpkeepAddEdit',
    name: E_RouterNames.inspectionUpkeepAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionUpkeep,
    },
    component: () => import(
    /* webpackChunkName: "spotCheck_InspectionUpkeep" */ "./view/InspectionUpkeepAddEdit/InspectionUpkeepAddEdit.vue"
    ),
},]

const routeDangers: RouteConfig[] = [{
    path: '/inspectionDanger',
    name: E_RouterNames.inspectionDanger,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionDanger" */ "./view/InspectionDanger/InspectionDanger.vue"
    ),
}, {
    path: '/inspectionDangerAddEdit',
    name: E_RouterNames.inspectionDangerAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionDanger,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionDanger" */ "./view/InspectionDangerAddEdit/InspectionDangerAddEdit.vue"
    ),
}, {
    path: '/inspectionDangerLib',
    name: E_RouterNames.inspectionDangerLib,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionDangerLib" */ "./view/InspectionDangerLib/InspectionDangerLib.vue"
    ),
}, {
    path: '/inspectionDangerLibAddEdit',
    name: E_RouterNames.inspectionDangerLibAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionDangerLib,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionDangerLib" */ "./view/InspectionDangerLibAddEdit/InspectionDangerLibAddEdit.vue"
    ),
},]

const routeArticles: RouteConfig[] = [{
    path: '/appArticles',
    name: E_RouterNames.appArticles,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionArticle" */ "./view/InspectionArticle/InspectionArticle.vue"
    ),
}, {
    path: '/appArticleAddEdit',
    name: E_RouterNames.appArticleAddEdit,
    meta: {
        parentName: E_RouterNames.appArticles,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionArticle" */ "./view/InspectionArticleAddEdit/InspectionArticleAddEdit.vue"
    ),
}, {
    path: '/appBanner',
    name: E_RouterNames.appBanner,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionArticle" */ "./view/InspectionBanner/InspectionBanner.vue"
    ),
}, {
    path: '/appBrief',
    name: E_RouterNames.appBrief,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionBriefAddEdit" */ "./view/InspectionBriefAddEdit/InspectionBriefAddEdit.vue"
    ),
}, {
    path: '/ask',
    name: E_RouterNames.ask,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionAsk" */ "./view/InspectionAsk/InspectionAsk.vue"
    ),
},]

const routeWeekReport: RouteConfig[] = [{
    path: '/inspectWeekReport',
    name: E_RouterNames.inspectWeekReport,
    component: () => import(
        /* webpackChunkName: "spotCheck_InspectWeekReport" */ "./view/InspectionWeek/weeklyReport.vue"
    ),
}, {
    path: "/inspectweeklyReportCreateAndEdit",
    name: E_RouterNames.inspectWeeklyReportCreateAndEdit,
    component: () =>
        import(
  /* webpackChunkName: "spotCheck_InspectWeekReport" */ "./view/InspectionWeek/weeklyReportCreateAndEdit/weeklyReportCreateAndEdit.vue"
        ),
    meta: {
        noMainLayoutComponent: true,
        keepDark: true,
        parentName: E_RouterNames.inspectWeekReport,
    }
}]


export const routes: RouteConfig[] = [
    {
    path: '/inspectionTaskPlan',
    name: E_RouterNames.inspectionTaskPlan,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionTaskPlan" */ "./view/InspectionTaskPlan/InspectionTaskPlan.vue"
    ),
    }, 
    {
    path: '/inspectionTaskPlanAddEdit',
    name: E_RouterNames.inspectionTaskPlanAddEdit,
    meta: {
      parentName: E_RouterNames.inspectionTaskPlan,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionTaskPlan" */ "./view/InspectionTaskPlan/InspectionTaskPlanAddEdit.vue"
    ),
    }, 
    {
    path: '/inspectionTaskPlanWave',
    name: E_RouterNames.inspectionTaskPlanWave,
    meta: {
      parentName: E_RouterNames.inspectionTaskPlan,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionTaskPlanWave" */ "./view/InspectionTaskPlanWave/InspectionTaskPlanWave.vue"
    ),
    }, 
    {
    path: '/inspectionTrend',
    name: E_RouterNames.inspectionTrend,
    meta: {
      parentName: E_RouterNames.inspectionTask,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionTrend" */ "./view/InspectionTrend/InspectionTrend.vue"
    ),
    },
    {
    path: '/inspectionTask',
    name: E_RouterNames.inspectionTask,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionTask" */ "./view/InspectionTask/InspectionTask.vue"
    ),
    },
    {
    path: '/instantInspection',
    name: E_RouterNames.instantInspection,
    component: () => import(
      /* webpackChunkName: "spotCheck_InstantInspection" */ "./view/InstantInspection/InstantInspection.vue"
    ),
    },
     {
    path: '/inspectionAlarm',
    name: E_RouterNames.inspectionAlarm,
    meta: {
      parentName: E_RouterNames.inspectionTask,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionTask" */ "./view/InspectionAlarm/InspectionAlarm.vue"
    ),
}, 


{
    path: '/inspectionTaskAddEdit',
    name: E_RouterNames.inspectionTaskAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionTask,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionTask" */ "./view/InspectionTaskAddEdit/InspectionTaskAddEdit.vue"
    ),
}, {
    path: '/inspectionTaskView',
    name: E_RouterNames.inspectionTaskView,
    meta: {
        parentName: E_RouterNames.inspectionTask,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionTask" */ "./view/InspectionTaskView/InspectionTaskView.vue"
    ),
}, {
    path: '/inspectionMapping',
    name: E_RouterNames.inspectionMapping,
    meta: {
        parentName: E_RouterNames.inspectionTask,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionMapping" */ "./view/InspectionMapping/InspectionMapping.vue"
    ),
}, {
    path: '/inspectionWave',
    name: E_RouterNames.inspectionWave,
    meta: {
        parentName: E_RouterNames.inspectionTask,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionWave" */ "./view/InspectionWave/InspectionWave.vue"
    ),
}, {
    path: '/inspectionStandard',
    name: E_RouterNames.inspectionStandard,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionStandard" */ "./view/InspectionStandard/InspectionStandard.vue"
    ),
}, {
    path: '/inspectionGroup',
    name: E_RouterNames.inspectionGroup,
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionGroup" */ "./view/InspectionGroup/InspectionGroup.vue"
    ),
}, {
    path: '/inspectionGroupAddEdit',
    name: E_RouterNames.inspectionGroupAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionGroup,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_InspectionGroupCreate" */ "./view/InspectionGroupAddEdit/InspectionGroupAddEdit.vue"
    ),
}, {
    path: '/inspectionPoint',
    name: E_RouterNames.inspectionPoint,
    component: () => import(
      /* webpackChunkName: "spotCheck_inspectionPoint" */ "./view/InspectionPoint/InspectionPoint.vue"
    ),
}, {
    path: '/inspectionPointAddEdit',
    name: E_RouterNames.inspectionPointAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionPoint,
    },
    component: () => import(
      /* webpackChunkName: "spotCheck_inspectionPoint" */ "./view/InspectionPointAddEdit/InspectionPointAddEdit.vue"
    ),
},
{
    path: '/inspectionArea',
    name: E_RouterNames.inspectionArea,
    component: () => import(
      /* webpackChunkName: "spotCheck_inspectionArea" */ "./view/InspectionArea/InspectionArea.vue"
    ),
}, {
    path: '/inspectionAreaEdit',
    name: E_RouterNames.inspectionAreaEdit,
    meta: {
        parentName: E_RouterNames.inspectionArea,
    },
    component: () => import(
    /* webpackChunkName: "spotCheck_inspectionArea" */ "./view/InspectionAreaEdit/InspectionAreaEdit.vue"
    ),
}, {
    path: '/inspectionLine',
    name: E_RouterNames.inspectionLine,
    component: () => import(
    /* webpackChunkName: "spotCheck_inspectionLine" */ "./view/InspectionLine/InspectionLine.vue"
    ),
}, {
    path: '/inspectionLineAddEdit',
    name: E_RouterNames.inspectionLineAddEdit,
    meta: {
        parentName: E_RouterNames.inspectionLine,
    },
    component: () => import(
    /* webpackChunkName: "spotCheck_inspectionLine" */ "./view/InspectionLineAddEdit/InspectionLineAddEdit.vue"
    ),
},
...routeWeekReport,
...routeDangers,
...routeUpkeep,
...routeRepair,
...routeArticles,
]
